export const animate_value = {
    height: "100%",
    opacity: "1"
}

export const initial_value = {
    height: "0px",
    opacity: "0"
}

export const transition_value = {
    type: "tween"
}
